import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IPopoverSurfaceEmptyProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Text from "../../../text";

const PopoverSurfaceEmpty: FC<IPopoverSurfaceEmptyProps> = ({
    customLocalize,
    customTheme,
    description,
    searchText,
    style,
    title,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const currentTitle = title ?? localize("no-results");

    const currentDescription = description ?? (searchText ? localize("no-results-for-search", [
        searchText
    ]) : undefined);

    const renderDescription = () => {
        if(!currentDescription) {
            return null;
        }

        return <Text
            customTheme={customTheme}
            variant="bodyMediumSize"
            style={stylesheet.text}
            color="mid"
        >
            {currentDescription}
        </Text>;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-live="polite"
        role="status"
    >
        <Text
            customTheme={customTheme}
            variant="labelMediumSize"
            style={stylesheet.text}
            color="high"
        >
            {currentTitle}
        </Text>
        {renderDescription()}
    </View>;
};
export default PopoverSurfaceEmpty;
